import {takeLatest} from "redux-saga/effects";
import * as ActionsTypes from "../../../../common/constants/stateConstants";
import {creationNouveauPackageSaga} from "./nouveauPackageSaga";

export default function* nouveauPackageWatcher() {
  yield takeLatest(
    ActionsTypes.CREATION_NOUVEAU_PACKAGE,
    creationNouveauPackageSaga
  );
}
